export default "/images/70e8a7993a37501e199adc67819c8667.png";